import React, { useState, useEffect } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { getTotalValueAvailable_Admin } from "../../../apis/revshare/AvailableHoursApi";

const AdminTotalAvailablePanel = ({ employeeNumber }) => {
  const [loading, setLoading] = useState(true);
  const [totalBalance, setTotalBalance] = useState(0.0);

  useEffect(() => {
    // Since this is an admin component, we're hardcoding isAdmin as true and ghost as false
    getTotalValueAvailable_Admin(employeeNumber)
      .then((total) => {
        setLoading(false);
        setTotalBalance(total);
      })
      .catch((error) => {
        console.error("Error fetching total available value:", error);
        setLoading(false);
      });
  }, [employeeNumber]);

  return (
    <Card className="total-balance-card popout-element">
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <span className="available-hours-total-balance">
              Available Balance: $
              {loading ? (
                <Spinner animation="border" size="sm" style={{ marginLeft: "10px", marginRight: "10px" }} />
              ) : (
                totalBalance.toFixed(2)
              )}
            </span>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AdminTotalAvailablePanel;